import {PendingActionExternalLinkHandler} from "../pending-action.external-link-handler";
import {UserController_GetPendingActionsRequest} from "../../../../api/api.service";
import {GNWP_SOURCES} from "../../../../gnwp/gnwp-consts";
import {
    PendingActionData,
    PendingActionResultEnum
} from "../pending-action.external-link-handler.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";
import {PlatformEventTypeEnum} from "../../../../../../common/enums/platform-event-type.enum";
import {IOpenRealGamePlayPendingActionOptions} from "./real-game-play-pending-action.external-link-handler.interface";
import {ExternalLinkInIframeRendererParams} from "../../external-link-in-iframe-handler-base";
import {CyClass} from "../../../../../../common/cy-classes";




export class RealGamePlayPendingActionExternalLinkHandler extends PendingActionExternalLinkHandler<IOpenRealGamePlayPendingActionOptions> {

    async openPendingAction(options?: IOpenRealGamePlayPendingActionOptions): Promise<PendingActionResultEnum> {
        if(options?.token) { //if we have a token it means we are on the old flow when we indirectly get a pending action as a response from platform getToken
            const url = await this.services.gnwp.getPendingPlayUrl({
                token: options?.token
            });
            await this._showExternalLinkDialog(url);
        } else {
            return super.openPendingAction(options);
        }

    }

    protected _createPendingActionsRequest(): UserController_GetPendingActionsRequest {
        return {
            eventTypeId: PlatformEventTypeEnum.Play,
            playModeId: 2 //1 = Demo, 2 = Real
        }
    }

    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.PENDING_PLAY;
    }

    protected async _getGnwpUrl(pendingActionData: PendingActionData, options?: IOpenRealGamePlayPendingActionOptions): Promise<string> {
        return await this.services.gnwp.getPendingPlayUrl({
            token: options?.token
        });
    }

    protected async _onPostMessageReceived(message: MessageEvent): Promise<void> {
        const actionId = this._extractActionId(message);

        if(!actionId) {
            return;
        }

        switch (actionId.toLowerCase()) {
            case '7':
                await this._openQuickDeposit({
                    promCode: this._extractPromoCode(message),
                    channel: {
                        source: CHANNEL_SOURCE.pendingPlay,
                        area: AreaType.PendingAction,
                        element: CHANNEL_ELEMENTS.depositButton
                    }
                });
                break;
            default:
                await super._onPostMessageReceived(message);
                break;
        }

        return super._onPostMessageReceived(message);
    }


    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            ...super._getIframeRendererParams(),
            iframeExtraCssClass: CyClass('cy-pending-play-external-link-container')
        };
    }
}